'use strict';

var _ = require('lodash');
var ChartLengthOfStayPercentageBarDirective = function ChartLengthOfStayPercentageBarDirective($filter) {
  return {
    restrict: 'E',
    template: require('../templates/chart-length-of-stay-percentage-bar.html'),
    replace: true,
    link: function link(scope, element) {
      var rmNumberFormat = $filter('rmNumberFormat');
      scope.$on('chart:lengthOfStay:sparseData', function (e, sparseColumns, chartParams) {
        element.width(chartParams.width + chartParams.padding.left - 2);
        element.find('.fare-change-list-item.label').width(chartParams.padding.left);
        scope.$evalAsync(function () {
          scope.setSparseColumns(sparseColumns);
        });
      });
      scope.setSparseColumns = function (sparseColumns) {
        scope.sparseColumns = _.map(sparseColumns, function (sparseColumn) {
          var percentage = sparseColumn.data.m1 / sparseColumn.data.m2 - 1;
          var fareChange = sparseColumn.data.m1 - sparseColumn.data.m2;
          return {
            width: sparseColumn.width,
            percentage: percentage ? rmNumberFormat(percentage, 'PERCENTAGE', true) : '-',
            value: fareChange ? rmNumberFormat(fareChange, 'NUMBER') : '-'
          };
        });
      };
    }
  };
};
ChartLengthOfStayPercentageBarDirective.$inject = ['$filter'];
module.exports = ChartLengthOfStayPercentageBarDirective;